export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "layoutTheme";

export const applyTheme = (theme: ThemeMode) => {
  document.body.setAttribute("data-bs-theme", theme);
  localStorage.setItem(STORAGE_KEY, theme);
};

export const loadTheme = (): ThemeMode => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "dark" ? "dark" : "light";
};
